export const customStyles = {
  header: {
    style: {
      minHeight: '56px',
      minWidth: '800px',
      fontWeight: 'bolder',
      color: '#000',
    },
  },
  headRow: {
    style: {},
  },
  headCells: {
    style: {
      fontSize: '18px',
    },
  },
  cells: {
    style: {
      minWidth: '800px',
    },
  },
};

export const pageOptions = {
  rowsPerPageText: 'Linhas Por Página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};

export const toggleOnStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  fontSize: 15,
  color: '#F2F2F2',
  paddingRight: 2,
  paddingBottom: 3,
};

export const toggleOffStyle = { ...toggleOnStyle, color: '#666666' };
